import React from 'react';
import ReactToPrint from 'react-to-print';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell
} from '@material-ui/core';

import moment from 'moment';
import 'devbox-linq';

function Imprimir(props) {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="form-dialog-title"
            maxWidth={"lg"}
            fullWidth
        >
            <DialogContent>
                <Grid container spacing={3} id="imprimir" style={{ padding: '50px' }}>
                    <Grid item xs={12} style={{ textAlign: 'right' }}>
                        <img src={process.env.PUBLIC_URL + '/logo.png'} alt="STK" height="80" />
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                        <Typography variant="h6" align="center" style={{ fontSize: '0.7rem' }}>
                            <b>Atividades executadas no período - {moment(props.data.dateFrom).format('DD/MM/YYYY')} à {moment(props.data.dateTo).format('DD/MM/YYYY')}</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                        <Typography variant="h6" align="left" style={{ fontSize: '0.7rem' }}>
                            <b>Responsável: {props.data.docs && props.data.docs.length > 0 && props.data.docs[0].responsavelItem.nome}</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Table>
                            <TableHead>
                                <TableRow key="datatable-header">
                                    <TableCell style={{ fontSize: '0.7rem' }} key="numeroOs" align="center"><b># OS</b></TableCell>
                                    <TableCell style={{ fontSize: '0.7rem' }} key="cliente" align="left"><b>Cliente</b></TableCell>
                                    <TableCell style={{ fontSize: '0.7rem' }} key="descricao" align="left"><b>Descrição</b></TableCell>
                                    <TableCell style={{ fontSize: '0.7rem' }} key="tarefa" align="left"><b>Tarefa</b></TableCell>
                                    <TableCell style={{ fontSize: '0.7rem' }} key="solicitacao" align="center"><b>Data Solicitação</b></TableCell>
                                    <TableCell style={{ fontSize: '0.7rem' }} key="prazo" align="center"><b>Prazo</b></TableCell>
                                    <TableCell style={{ fontSize: '0.7rem' }} key="conclusao" align="center"><b>Conclusão</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.data.docs?.map((tarefa, index) => (
                                    <TableRow key={'tarefa-' + index}>
                                        <TableCell style={{ fontSize: '0.7rem' }} align="center">{tarefa.numeroOs}</TableCell>
                                        <TableCell style={{ fontSize: '0.7rem' }} align="left">{tarefa.nomeCliente}</TableCell>
                                        <TableCell style={{ fontSize: '0.7rem' }} align="left">{tarefa.descricaoOs}</TableCell>
                                        <TableCell style={{ fontSize: '0.7rem' }} align="left">{tarefa.nome}</TableCell>
                                        <TableCell style={{ fontSize: '0.7rem' }} align="center">{moment(tarefa.data).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                        <TableCell style={{ fontSize: '0.7rem' }} align="center">{moment(tarefa.prazo).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                        <TableCell style={{ fontSize: '0.7rem' }} align="center">{moment(tarefa.conclusao).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Grid>

                    <Grid item xs={12} style={{ fontSize: '0.7rem' }}>
                        <p>São Bento do Sul, {moment().format("DD [de] MMMM [de] YYYY")}</p>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                {props.confirm &&
                    <ReactToPrint
                        trigger={() => {
                            return <Button color="primary" autoFocus>Imprimir</Button>
                        }}
                        content={() => document.getElementById("imprimir")}
                    />}
                {props.cancel && <Button onClick={props.cancel}>Cancelar</Button>}
            </DialogActions>
        </Dialog >
    )
}

export default Imprimir;